import styled, { css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const OuterWrapper = styled.div`
    font-size: ${props => props.theme.typography.font.size.small};
    font-family: ${props => props.theme.typography.font.family.latoVerdana};
    display: ${props => props.theme.style.display.flex};
    flex-wrap: ${props => props.theme.style.flexWrap.wrap};
`
export const InnerWrapper = styled.div`
    flex-basis: ${props => props.theme.layout.fill};
    max-width: ${props => props.theme.layout.fill};
    width: ${props => props.theme.layout.fill};
    padding: 0 0.625rem 0 0;
    min-height: 2.25rem;
`

export const OuterSection = styled.div`
    display: ${props => props.theme.style.display.block};
    white-space: nowrap;
    overflow-x: auto;
    ::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
`

export const PopularFilterLink = styled.a`
    ${({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: 0.875rem;
        font-weight: 400;
        margin-right: 0.75rem;
        line-height: 1.375rem;
        color: #282828;
        background: ${theme.colors.white};
        display: ${theme.style.display.inlineFlex};
        padding: 5px 12px;
        border: 1px solid #d5d5d5;
        text-decoration: none;
        align-items: ${theme.style.alignItems.center};
        border-radius: 8rem;
        text-align: ${theme.style.textAlign.center};
        cursor: pointer;

        :hover {
            background-color: #f6f6f6;
            border-color: #282828;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-right: 0.75rem;
        }

        &:last-child {
            margin-right: 0;
        }
    `}
`
